'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.values = exports.BRNO_ID = exports.TOKEN = exports.PORTAL_PRAZANA = exports.MOJE_ID = exports.ISDS = exports.NIA = exports.JMENO_HESLO = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _params;

exports.getCaption = getCaption;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// @Conf
// #hasDoc=true

// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2024-05-22T17:58:52Z                      #

// ##############################################################

/**
 * Typ autentizace k účtu.
 */

var JMENO_HESLO = exports.JMENO_HESLO = 'JMENO_HESLO';

var NIA = exports.NIA = 'NIA';

var ISDS = exports.ISDS = 'ISDS';

var MOJE_ID = exports.MOJE_ID = 'MOJE_ID';

var PORTAL_PRAZANA = exports.PORTAL_PRAZANA = 'PORTAL_PRAZANA';

var TOKEN = exports.TOKEN = 'TOKEN';

var BRNO_ID = exports.BRNO_ID = 'BRNO_ID';

/**
 * Seznam všech hodnot.
 */
var values = exports.values = [JMENO_HESLO, NIA, ISDS, MOJE_ID, PORTAL_PRAZANA, TOKEN, BRNO_ID];

/**
 * Mapa enumu na objekt s podrobnostmi o enumu.
 */
var params = (_params = {}, (0, _defineProperty3.default)(_params, JMENO_HESLO, { caption: '' }), (0, _defineProperty3.default)(_params, NIA, { caption: '' }), (0, _defineProperty3.default)(_params, ISDS, { caption: '' }), (0, _defineProperty3.default)(_params, MOJE_ID, { caption: '' }), (0, _defineProperty3.default)(_params, PORTAL_PRAZANA, { caption: '' }), (0, _defineProperty3.default)(_params, TOKEN, { caption: '' }), (0, _defineProperty3.default)(_params, BRNO_ID, { caption: '' }), _params);

/**
 * Načtení popisku enumu.
 * @return popisek enumu
 */
function getCaption(value) {
  return params[value].caption;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9saWIvYXBpL2dlbi91Y3R5L3YxL1R5cEF1dGVudGl6YWNlLmpzeCJdLCJuYW1lcyI6WyJnZXRDYXB0aW9uIiwiSk1FTk9fSEVTTE8iLCJOSUEiLCJJU0RTIiwiTU9KRV9JRCIsIlBPUlRBTF9QUkFaQU5BIiwiVE9LRU4iLCJCUk5PX0lEIiwidmFsdWVzIiwicGFyYW1zIiwiY2FwdGlvbiIsInZhbHVlIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7O1FBMkRnQkEsVSxHQUFBQSxVOzs7O0FBM0RoQjtBQUNBOztBQUVBOztBQUVBOztBQUVBOztBQUVBOztBQUVBOzs7O0FBSU8sSUFBTUMsb0NBQWMsYUFBcEI7O0FBRUEsSUFBTUMsb0JBQU0sS0FBWjs7QUFFQSxJQUFNQyxzQkFBTyxNQUFiOztBQUVBLElBQU1DLDRCQUFVLFNBQWhCOztBQUVBLElBQU1DLDBDQUFpQixnQkFBdkI7O0FBRUEsSUFBTUMsd0JBQVEsT0FBZDs7QUFFQSxJQUFNQyw0QkFBVSxTQUFoQjs7QUFFUDs7O0FBR08sSUFBTUMsMEJBQVMsQ0FDbEJQLFdBRGtCLEVBRWxCQyxHQUZrQixFQUdsQkMsSUFIa0IsRUFJbEJDLE9BSmtCLEVBS2xCQyxjQUxrQixFQU1sQkMsS0FOa0IsRUFPbEJDLE9BUGtCLENBQWY7O0FBVVA7OztBQUdBLElBQU1FLCtEQUNEUixXQURDLEVBQ2EsRUFBQ1MsU0FBUyxFQUFWLEVBRGIsMENBRURSLEdBRkMsRUFFSyxFQUFDUSxTQUFTLEVBQVYsRUFGTCwwQ0FHRFAsSUFIQyxFQUdNLEVBQUNPLFNBQVMsRUFBVixFQUhOLDBDQUlETixPQUpDLEVBSVMsRUFBQ00sU0FBUyxFQUFWLEVBSlQsMENBS0RMLGNBTEMsRUFLZ0IsRUFBQ0ssU0FBUyxFQUFWLEVBTGhCLDBDQU1ESixLQU5DLEVBTU8sRUFBQ0ksU0FBUyxFQUFWLEVBTlAsMENBT0RILE9BUEMsRUFPUyxFQUFDRyxTQUFTLEVBQVYsRUFQVCxXQUFOOztBQVVBOzs7O0FBSU8sU0FBU1YsVUFBVCxDQUFvQlcsS0FBcEIsRUFBMkI7QUFDOUIsU0FBT0YsT0FBT0UsS0FBUCxFQUFjRCxPQUFyQjtBQUNIIiwiZmlsZSI6IlR5cEF1dGVudGl6YWNlLmpzIiwic291cmNlc0NvbnRlbnQiOlsiLy8gQENvbmZcbi8vICNoYXNEb2M9dHJ1ZVxuXG4vLyAjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjI1xuXG4vLyAjICAgICAgICAgICAgIEdFTkVST1ZBTsOdIEvDk0QsIE5FTU9ESUZJS09WQVQhISEhICAgICAgICAgICAgICAjXG5cbi8vICMgICAgICAgICAgICAgICAgICAyMDI0LTA1LTIyVDE3OjU4OjUyWiAgICAgICAgICAgICAgICAgICAgICAjXG5cbi8vICMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjXG5cbi8qKlxuICogVHlwIGF1dGVudGl6YWNlIGsgw7rEjXR1LlxuICovXG5cbmV4cG9ydCBjb25zdCBKTUVOT19IRVNMTyA9ICdKTUVOT19IRVNMTyc7XG5cbmV4cG9ydCBjb25zdCBOSUEgPSAnTklBJztcblxuZXhwb3J0IGNvbnN0IElTRFMgPSAnSVNEUyc7XG5cbmV4cG9ydCBjb25zdCBNT0pFX0lEID0gJ01PSkVfSUQnO1xuXG5leHBvcnQgY29uc3QgUE9SVEFMX1BSQVpBTkEgPSAnUE9SVEFMX1BSQVpBTkEnO1xuXG5leHBvcnQgY29uc3QgVE9LRU4gPSAnVE9LRU4nO1xuXG5leHBvcnQgY29uc3QgQlJOT19JRCA9ICdCUk5PX0lEJztcblxuLyoqXG4gKiBTZXpuYW0gdsWhZWNoIGhvZG5vdC5cbiAqL1xuZXhwb3J0IGNvbnN0IHZhbHVlcyA9IFtcbiAgICBKTUVOT19IRVNMTyxcbiAgICBOSUEsXG4gICAgSVNEUyxcbiAgICBNT0pFX0lELFxuICAgIFBPUlRBTF9QUkFaQU5BLFxuICAgIFRPS0VOLFxuICAgIEJSTk9fSURcbl07XG5cbi8qKlxuICogTWFwYSBlbnVtdSBuYSBvYmpla3QgcyBwb2Ryb2Jub3N0bWkgbyBlbnVtdS5cbiAqL1xuY29uc3QgcGFyYW1zID0ge1xuICAgIFtKTUVOT19IRVNMT106IHtjYXB0aW9uOiAnJ30sXG4gICAgW05JQV06IHtjYXB0aW9uOiAnJ30sXG4gICAgW0lTRFNdOiB7Y2FwdGlvbjogJyd9LFxuICAgIFtNT0pFX0lEXToge2NhcHRpb246ICcnfSxcbiAgICBbUE9SVEFMX1BSQVpBTkFdOiB7Y2FwdGlvbjogJyd9LFxuICAgIFtUT0tFTl06IHtjYXB0aW9uOiAnJ30sXG4gICAgW0JSTk9fSURdOiB7Y2FwdGlvbjogJyd9XG59O1xuXG4vKipcbiAqIE5hxI10ZW7DrSBwb3Bpc2t1IGVudW11LlxuICogQHJldHVybiBwb3Bpc2VrIGVudW11XG4gKi9cbmV4cG9ydCBmdW5jdGlvbiBnZXRDYXB0aW9uKHZhbHVlKSB7XG4gICAgcmV0dXJuIHBhcmFtc1t2YWx1ZV0uY2FwdGlvbjtcbn0iXX0=